export { spaceRemover } from './spaceRemover'
export { urlValue } from './url'
export { projectContext, ProjectProvider } from './projectContext'
export { loadingContext, LoadingProvider } from './loadingContext'
export { intentsContext, IntentsProvider } from './intentsContext'
export { validContext, ValidProvider } from './validContext'
export { msalConfig, loginRequest } from './authConfig'
export { unfolder, encrypter } from './CryptoMethods'
export {getCookie, setCookie, eraseCookie} from './CookiesMethod'
export {onImportExcelAsync,downloadFile} from './ImportExcel'
export {animateCSS, openModalVw, closeModalVw, openAlert, closeAlert} from './AnimationsCss'

export function groupBy(array, key) {
    return array.reduce((result, currentItem) => {
        
        const groupKey = currentItem[key];
 
        if (!result[groupKey]) {
            result[groupKey] = [];
        } 
         
        result[groupKey].push(currentItem);

        return result;
    }, {});
}